module.exports = __webpack_public_path__ + "img/img4.b8adf1d9.svg";